// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2PSta","vLegacy":"SelectSecondary_vLegacy__3a_Z1","error":"SelectSecondary_error__U3ivi","disabled":"SelectSecondary_disabled__UjK20"};